'use client'
import { useState, useRef } from 'react'
import { Dialog } from '@headlessui/react'
import { RiWhatsappFill } from 'react-icons/ri'
import Image from 'next/image'
import Link from 'next/link'
import { IoLogoWhatsapp } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FaLine, FaPhoneSquareAlt } from 'react-icons/fa'
import tailwindConfig from '@tailwind.config'
import QRCodeGenerator from '@components/QRCodeGenerator'

const AgentCard = ({ property, dictionary, lang }) => {
    const [phoneQrIsOpen, setPhoneQrIsOpen] = useState(false)  
    const [waQrIsOpen, setWaQrIsOpen] = useState(false)  
    const [lineQrIsOpen, setLineQrIsOpen] = useState(false)  
    const [isCopied, setIsCopied] = useState(false);
    const spanRef = useRef(null);

    const copyToClipboard = () => {
        if (spanRef && spanRef.current) {
          const tempInput = document.createElement('input');
          tempInput.value = property.agent.agentContact;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000); // Reset copied state after 2 seconds
        }
      };

    return (
        <div className='sm:flex hidden relative w-full flex-col overflow-hidden border-[1px] border-grey-300 shadow-sm rounded-md'>
            {/* <div className='overflow-hidden w-full h-full'>
                <Image 
                    src={'/images/contactbg.jpg'}
                    width={400}
                    height={600}
                    className='object-none'
                    // className='object-fit'
                />
            </div> */}
            {/* <div className='z-10 absolute top-0 left-0 right-0 bottom-0 bg-light bg-opacity-80'></div> */}
            <div className='z-20 flex flex-col justify-between items-center p-2'>
                <div className='w-full flex flex-row pt-2'>
                    {/* <Link href={`/agents/${property.agent.slug}`}> */}
                        <div className='relative w-[60px] aspect-square rounded-md overflow-hidden'>
                            <Image
                                // placeholder="blur"
                                // blurDataURL={property.blur}
                                // className='object-fit'
                                className='object-cover hover:shadow-xl'
                                src={`/images/remaxlogo.png`}
                                // src={`https://rstbase.com/images/agents/${property.agent._id}/${property.agent.cover}`}
                                // width={imageWidth}
                                // height={imageHeight}
                                fill={true}
                                // alt={property.slug}
                            />
                        </div>
                    {/* </Link> */}
                    <div className='ml-2 flex flex-col justify-between'>
                        <div>
                            {/* <p className='text-maincolor font-bold'>{property.agent.agentName}</p> */}
                            {/* <p className='text-secondary'>{property.agent.position}</p> */}
                            <p className='text-secondary text-xl font-bold'>{lang !== 'cn' ? 'RE/MAX Capital Property' : '芭提雅亚都地产'}</p>
                            <p className='text-secondary'>{lang !== 'cn' ? 'Pattaya Real Estate' : '一站式中文服务'}</p>
                        </div>
                    </div>
                </div>
                <div className='w-full mt-2'>
                    <p className='text-maincolor font-semibold text-md text-center'>{dictionary.title}</p>
                    <div className='flex flex-col'>
                        {property.agent.agentWhatsapp && (
                            <button onClick={() => {setWaQrIsOpen(true)}} title='WhatsApp' href={`${property.agent.agentWhatsapp}`} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' >
                                <IoLogoWhatsapp
                                    color={tailwindConfig.theme.extend.colors.light}
                                    size={30}
                                    className=''
                                />
                                <span className='w-[90px] text-center text-light font-semibold ml-2'>Whatsapp</span>
                            </button>
                        )}
                        {property.agent.agentLine && (
                            <button onClick={() => {setLineQrIsOpen(true)}} title='LINE' href={property.agent.agentLine} className='flex flex-row my-1 justify-center w-full inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                                <FaLine
                                    color={tailwindConfig.theme.extend.colors.light}
                                    size={30}
                                    className=''
                                />
                                <span className='w-[90px] text-center text-light font-semibold ml-2'>LINE</span>
                            </button>
                        )}
                        {property.agent.agentContact && (
                            <button onClick={() => {setPhoneQrIsOpen(true)}} title='Mobile' href={`tel:${property.agent.agentContact}`} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#FF0000] to-[#e90b0b] hover:from-[#e90b0b] hover:to-[#FF0000] py-1 px-1 mx-[1px] items-center rounded-md shadow-sm drop-shadow-md' target="_blank">
                                <FaPhoneSquareAlt
                                    color={tailwindConfig.theme.extend.colors.light}
                                    size={30}
                                    className=''
                                />
                                <span className='w-[90px] text-center text-light font-semibold ml-2'>{dictionary.agentPhone}</span>
                            </button>
                        )}
                        <Dialog
                            open={waQrIsOpen}
                            onClose={() => setWaQrIsOpen(false)}
                            className="relative z-50"
                        >
                            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                    <Dialog.Title>
                                        <div className='flex flex-row justify-between items-center'>
                                            <span className='text-maincolor'>
                                                {property.agent.agentName}'s WhatsApp
                                            </span>
                                            <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setWaQrIsOpen(false)}}>
                                                <IoClose 
                                                    size={16}
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                />
                                            </button>
                                        </div>
                                    </Dialog.Title>
                                    <div className='flex flex-col items-center'>
                                        <QRCodeGenerator url={`${property.agent.agentWhatsapp}`} />
                                        <div className='w-full flex flex-row justify-center items-center'>
                                            <Link className='w-full bg-[#25D366] text-light p-2 rounded-md text-center' href={property.agent.agentWhatsapp}>Open WhatsApp in Web Browser</Link>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </Dialog>
                        <Dialog
                            open={lineQrIsOpen}
                            onClose={() => setLineQrIsOpen(false)}
                            className="relative z-50"
                        >
                            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                    <Dialog.Title>
                                        <div className='flex flex-row justify-between items-center'>
                                            <span className='text-maincolor'>
                                                {property.agent.agentName}'s LINE
                                            </span>
                                            <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setLineQrIsOpen(false)}}>
                                                <IoClose 
                                                    size={16}
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                />
                                            </button>
                                        </div>
                                    </Dialog.Title>
                                    <div className='flex flex-col items-center'>
                                        <QRCodeGenerator url={`${property.agent.agentLine}`} />
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </Dialog>
                        <Dialog
                            open={phoneQrIsOpen}
                            onClose={() => setPhoneQrIsOpen(false)}
                            className="relative z-50"
                        >
                            <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                            <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                    <Dialog.Title>
                                        <div className='flex flex-row justify-between items-center'>
                                            <span className='text-maincolor'>
                                                {property.agent.agentName}'s Phone Number
                                            </span>
                                            <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-md w-[30px] h-[30px]' onClick={() => {setPhoneQrIsOpen(false)}}>
                                                <IoClose 
                                                    size={16}
                                                    color={tailwindConfig.theme.extend.colors.light}
                                                />
                                            </button>
                                        </div>
                                    </Dialog.Title>
                                    <div className='flex flex-col items-center'>
                                        <QRCodeGenerator url={`tel:${property.agent.agentContact}`} />
                                        <div className='w-full flex flex-row justify-center items-center'>
                                            <span ref={spanRef} className='text-maincolor'>{property.agent.agentContact}</span>
                                            <button title='Click to copy to clipboard' onClick={copyToClipboard} className='bg-maincolor text-light p-2 rounded-md ml-4'>{isCopied ? 'Copied!' : 'Copy'}</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgentCard